export class UserCardTypeTemplateApiModel {
  id: string;

  graphic: string;
}
